// Canonical SanMar size order. PromoStandards labelSize values we see
// in the wild use the numbered forms (2XL/3XL/...); legacy XXL/XXXL
// spellings are kept as a safety net. N/A is the OSFA/CUSTOM sentinel
// from the backend normalizer.
const CANONICAL_ORDER = Object.freeze([
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "6XL",
    "7XL",
    "8XL",
    "XXL",
    "XXXL",
    "N/A",
]);

const CANONICAL_INDEX = new Map(
    CANONICAL_ORDER.map((sz, i) => [sz, i]),
);

/**
 * Given an array of color rows (each with a `sizes` object keyed by size
 * label), return the sorted list of unique sizes that appear anywhere in
 * the data.
 *
 * Sizes in CANONICAL_ORDER come first in that order; any unknown size
 * is appended at the end, sorted alphabetically for determinism.
 *
 * Sizes returning null/0 ARE included if any row has the key. The
 * caller is responsible for rendering null cells as em-dash, not us.
 *
 * Returns an empty array when colors is empty/null/undefined.
 */
export function deriveInventorySizes(colors) {
    if (!Array.isArray(colors) || colors.length === 0) return [];
    const seen = new Set();
    for (const c of colors) {
        if (!c || typeof c.sizes !== "object" || c.sizes === null) continue;
        for (const sz of Object.keys(c.sizes)) {
            if (sz) seen.add(sz);
        }
    }
    const known = [];
    const unknown = [];
    for (const sz of seen) {
        if (CANONICAL_INDEX.has(sz)) known.push(sz);
        else unknown.push(sz);
    }
    known.sort((a, b) => CANONICAL_INDEX.get(a) - CANONICAL_INDEX.get(b));
    unknown.sort(); // alphabetical
    return [...known, ...unknown];
}
